import utils from './../../utils.js';

export default utils.generateNamespace({
	state: [
		'HIERARCHY_STATE',
		'AVAILABLE_JIRA_VALUES',
		'IS_EPIC_TYPE_MAPPED',
		'IS_EPIC_NAME_MAPPED',
        'IS_NEXT_GEN',
		'WAITING_FOR_RESPONSE',
		'SELECTED_JIRA_LINK'
	],
	actions: [
		'FETCH_HIERARCHY_STATE',
		'UPDATE_HIERARCHY_STATE',
		'SET_UP_SERVICE',
		'HANDLE_ERROR'
	],
	mutations: [
		'UPDATE_HIERARCHY_STATE',
		'SET_AVAILABLE_JIRA_VALUES',
		'SET_IS_EPIC_TYPE_MAPPED',
		'SET_IS_EPIC_NAME_MAPPED',
        'SET_IS_NEXT_GEN',
		'ENABLE_VIEW',
		'DISABLE_VIEW',
		'UPDATE_JIRA_LINK'
	],
	getters: [
		'HIERARCHY_STATE',
		'AVAILABLE_JIRA_VALUES',
		'IS_EPIC_TYPE_MAPPED',
		'IS_EPIC_NAME_MAPPED',
        'IS_NEXT_GEN',
		'JIRA_LINK_TITLE',
		'WAITING_FOR_RESPONSE'
	],
	default: {
		TFS_LINK_TYPE: 'Parent / Child Link'
	}
});



// WEBPACK FOOTER //
// ./src/store/modules/hierarchy/namespace.js